
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const constantRouterMap = [
  {
    path: '/',
    redirect: 'login'
  },
  {//cas登录
    path: '/login',
    name: 'login',
    component: resolve => require(['@/view/login.vue'], resolve),
  },
  {//登录
    path: '/loginSpare',
    name: 'loginSpare',
    component: resolve => require(['@/view/loginSpare.vue'], resolve),
  },
  {
    path: '/test',
    name: 'test',
    component: resolve => require(['@/view/test.vue'], resolve),
  },
  {
    path: '/echartTest',
    name: 'echartTest',
    component: resolve => require(['@/view/echartTest.vue'], resolve),
  },
  {
    path: '/liveDialog1',
    name: 'liveDialog1',
    component: resolve => require(['@/components/common/liveDialog1.vue'], resolve),
  },
  {
    path: '/liveDialog2',
    name: 'liveDialog2',
    component: resolve => require(['@/components/common/liveDialog2.vue'], resolve),
  },
  { // 校区
    name: 'home',
    path: '/home',
    component: resolve => require(['@/view/home/index.vue'], resolve),
  },
  // { // 校区
  //   name: 'apphome',
  //   path: '/appHome',
  //   component: resolve => require(['@/view/appHome/home.vue'], resolve),
  // },
  {
    path: '/',
    redirect: '/campus',
    component: resolve => require(['@/components/common/layout.vue'], resolve),
    children: [

      { // 校区
        name: 'campus',
        path: 'campus',
        component: resolve => require(['@/view/campus/index.vue'], resolve),
      },
      { // 楼栋
        name: 'building',
        path: 'building',
        component: resolve => require(['@/view/building/index.vue'], resolve),
      },
      { // 楼层
        name: 'floor',
        path: 'floor',
        component: resolve => require(['@/view/floor/index.vue'], resolve),
      },
      { // 教室
        path: 'classRoom',
        name: 'classRoom',
        component: resolve => require(['@/view/classRoom/index.vue'], resolve),
      }
    ]
  },
  {
    path: '/401',
    component: resolve => require(['@/components/base/401'], resolve)
  },
  {
    path: '*',
    component: resolve => require(['@/components/base/404'], resolve)
  }
]

const router = new Router({
  mode: 'history',
  // base: '/xz/',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
export default router